// /forgot-password
import { API } from "../../apiSlice";

export const forgotPasswordApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    forgotPassword: builder.mutation({
      query: (data) => {
        return {
          url: "users/forgot-password",
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const { useForgotPasswordMutation } = forgotPasswordApiSlice;
